import * as React from 'react';

import { compose } from '../../../../../utils/component-helpers';

import { withResourceEdges } from '@cube3/state/src/redux/components/withResourceEdges';

import { withModalActions, ModalActionProps } from '../../Modals/modalActions';
import { ModalReceiverProps } from '../../Modals/ModalManager';
import { withRouter } from 'react-router-dom';
import withCurrentWorkspace from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';

import DetailViewMetaData from '../../ContentPane/DetailView/MainTabs/DetailViewMetaData';
import { MobileSubmenuSlider } from '@cube3/cubicle/src/components/Surface/MobileSubmenuSlider';

/**Display the metadata view in a modal when isMobile */

type Properties = ModalActionProps & ModalReceiverProps & MobileMetadata;

interface MobileMetadata {}

function MobileMetadata(props: Properties): JSX.Element {
  const { modalContext, previousModal } = props;

  return (
    <MobileSubmenuSlider onClose={previousModal}>
      <DetailViewMetaData asset={modalContext} />
    </MobileSubmenuSlider>
  );
}

export default compose(MobileMetadata)(
  withRouter,
  withCurrentWorkspace,
  withModalActions,
  withResourceEdges({
    resourceType: 'asset',
    resourceId: (props: Properties) => props.modalContext,
    edgeType: 'metadata-category',
    edgeLabel: 'metadata-categories',
    mapper: 'retrievedForms'
  })
);
